import store from '@/store';

import Generic from './Generic.vue';
import Menus from './Menus.vue';
import Redirects from './Redirects.vue';
import Users from './Users.vue';
import Storage from './Storage.vue';

async function fontOptions() {
  const fonts = await store.dispatch('loadGoogleFonts');

  return fonts.map((font) => ({
    label: font,
    value: font,
  }));
}

export const initialView = 'site';

export default {
  site: {
    label: 'Configurações gerais',
    component: Generic,
    groups: [
      {
        label: 'Google Tag Manager (GTM)',
        helpText:
          'Espaço que permite inserir alterações via tags no site sem alterar o código. <a href="https://marketingplatform.google.com/about/tag-manager/" target="_blank">Saiba mais</a>.',
        fields: [
          {
            name: 'globalGtm',
            type: 'ShortText',
            maxlength: 12,
            mask: {
              // imaskjs options
              mask: /^[A-Z0-9-]+$/,
              prepare(str) {
                return str.toUpperCase();
              },
            },
            validation: {
              format: {
                pattern: /^(GTM-[A-Z0-9]{4,8})?$/,
                message: 'ID do GTM inválido.',
              },
            },
          },
        ],
      },
      {
        label: 'Favicon',
        helpText: 'Tamanho máx. de 192px por 192px.',
        fields: [
          {
            name: 'favicon',
            type: 'ImageFile',
            maxWidth: 192,
            maxHeight: 192,
            enableRemoval: true,
          },
        ],
      },
      {
        label: 'Metatags',
        helpText: `As metatags serão inseridas em todas as páginas do site, e devem seguir o padrão <i>&ltmeta name="nomedatag" content="conteudo" /&gt</pre></i>.
          <br><br>Saiba mais sobre metatags <a href="https://developers.google.com/search/docs/advanced/crawling/special-tags?hl=pt-br" target="_blank">aqui</a>.`,
        fields: [
          {
            name: 'metatags',
            type: 'LongText',
            placeholder:
              '<meta name="facebook-domain-verification" content="xyzw123" />',
            spellcheck: false,
            validation: {
              format: {
                pattern:
                  /^(<meta name=["'][\w-]+["'] content=["'][\w-]+["'] \/>\n?)*$/,
                message:
                  'Metatag inválida.<br>Verifique se a tag contém os atributos <b>name</b> e <b>content</>.',
              },
            },
          },
        ],
      },
      {
        label: 'Código no cabeçalho <head>',
        helpText: `Neste campo é possível inserir tags do tipo &ltscript&gt ao cabeçalho do site. As modificações são visíveis apenas nas suas páginas publicadas.`,
        warning: 'Atenção: o código é replicado em todas as páginas do site.',
        fields: [
          {
            name: 'headScript',
            type: 'HTMLEditor',
            placeholder: '<script>\nseuCodigo();\n</script>',
          },
        ],
      },
    ],
  },
  domain: {
    label: 'Configurações de domínio',
    component: Generic,
    groups: [
      {
        label: 'Domínio personalizado',
        helpText:
          'Para adicionar um domínio personalizado, é necessário que o DNS seja apontado para o Lets Sites e configurado também pela equipe de infraestrutura.',
        warning:
          'Atenção: ao alterar este campo, é preciso cadastrar um novo token de Lets CRM que seja válido para o novo domínio.',
        fields: [
          {
            name: 'domain',
            placeholder: 'www.hotelexemplo.com',
            type: 'Tags',
            pattern: /^([a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,6})?$/,
          },
        ],
      },
    ],
  },
  appearance: {
    label: 'Configurações de aparência',
    component: Generic,
    groups: [
      {
        label: 'Fontes customizadas',
        preview: {
          heading: 'Cabeçalho de exemplo',
          body: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Ratione aut sit ipsa tempora est corporis fugiat nesciunt, asperiores cumque beatae obcaecati.',
        },
        fields: [
          {
            name: 'headingFont',
            label: 'Fonte dos cabeçalhos',
            type: 'VueSelect',
            options: {
              source: 'store',
              handler: fontOptions,
            },
          },
          {
            name: 'bodyFont',
            label: 'Fonte do corpo',
            type: 'VueSelect',
            options: {
              source: 'store',
              handler: fontOptions,
            },
          },
        ],
      },
    ],
  },
  letsbook: {
    label: 'Integração com Letsbook',
    component: Generic,
    groups: [
      {
        label: 'URL do Letsbook',
        helpText: 'URL de acesso do seu CMS Letsbook',
        fields: [
          {
            name: 'letsbookUrl',
            placeholder: 'ex.: https://example.letsbook.com.br/Admin/',
            type: 'ShortText',
            validation: {
              format: {
                message:
                  'URL do Letsbook inválida, informe uma URL nesse padrão <b>https://example.letsbook.com.br/Admin/</b>',
                pattern:
                  /^https:\/\/([a-z0-9]+)\.letsbook\.com\.br\/Admin\/?$/i,
              },
            },
          },
        ],
      },
      {
        label: 'Letsbook API ID',
        helpText: 'O identificador da sua aplicação Letsbook',
        fields: [
          {
            name: 'letsbookApiId',
            placeholder: 'ex.: EXAMPLE',
            type: 'ShortText',
            validation: {
              format: {
                message: 'Letsbook API ID inválida',
                pattern: /[A-Z0-9]+$/i,
              },
            },
          },
        ],
      },
      {
        label: 'Agrupador de hotéis principal',
        helpText:
          'O agrupador geral de hotéis para seu site. Ele será utilizado para buscar dados gerais cadastrados no Motor Letsbook como hotéis e promoções',
        fields: [
          {
            name: 'letsbookLandingPageId',
            type: 'SelectLandingPageId',
          },
        ],
      },
    ],
  },
  crm: {
    label: 'Integração com CRM',
    component: Generic,
    groups: [
      {
        label: 'Token do CRM',
        helpText: 'O token do CRM deve ser solicitado a equipe de CRM',
        fields: [
          {
            name: 'crmToken',
            placeholder: 'Digite o token do CRM',
            type: 'LongText',
            validation: {
              length: {
                minimum: 40,
                tooShort: 'Token do CRM inválido',
              },
            },
          },
        ],
      },
      {
        label: 'URL do CRM',
        helpText: 'URL de acesso do seu CRM',
        fields: [
          {
            name: 'crmUrl',
            placeholder: 'ex.: https://crm.pmweb.com.br/example/',
            type: 'ShortText',
            validation: {
              format: {
                message:
                  'URL do CRM inválida, informe uma URL nesse padrão <b>https://crm.pmweb.com.br/example/</b>',
                pattern: /(https:\/\/crm\.pmweb\.com\.br\/)+([a-zA-Z_]+)+(\/)/,
              },
            },
          },
        ],
      },
    ],
  },
  email: {
    label: 'Configurações de e-mail',
    component: Generic,
    groups: [
      {
        label: 'E-mails de contato',
        helpText:
          'Endereços de destino para serem selecionados nos módulos de submissão de formulário',
        fields: [
          {
            name: 'emails',
            type: 'Tags',
            placeholder: 'jane.doe@example.com',
            pattern:
              /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i,
          },
        ],
      },
      {
        label: 'Destinatários LGPD',
        helpText: 'E-mails de destino para o formulário de LGPD',
        fields: [
          {
            name: 'lgpdRecipients',
            type: 'Tags',
            placeholder: 'jane.doe@example.com',
            pattern:
              /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i,
          },
        ],
      },
    ],
  },
  storage: {
    label: 'Banco de imagens',
    component: Storage,
  },
  menus: {
    label: 'Menus globais',
    component: Menus,
    async beforeEnter() {
      await store.dispatch('loadGlobals', { endpoint: 'globals' });
    },
  },
  redirects: {
    label: 'Redirecionamentos',
    component: Redirects,
    async beforeEnter() {
      await store.dispatch('loadRedirects');

      if (Object.keys(store.state.pages).length === 0) {
        await store.dispatch('loadPages');
      }
    },
  },
  users: {
    label: 'Usuários',
    component: Users,
    async beforeEnter() {
      await store.dispatch('loadUsers');
    },
    isEnabled(user) {
      return user?.role === 'admin';
    },
  },
};
